<template>
  <div class="mt-2">
    <v-list dense shaped color="transparent">
      <v-list-item-group color="primary">
        <v-subheader>Types</v-subheader>

        <v-list-item to="/rgps/corneal">
          <v-list-item-icon class="mx-0">
            <img :src="iconPath + 'rgp_icon.svg'" width="22" class="mr-2" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Corneal</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/rgps/scleral">
          <v-list-item-icon class="mx-0">
            <img :src="iconPath + 'scleral_icon.svg'" width="22" class="mr-2" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Sclerals</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/rgps/ortho-k">
          <v-list-item-icon class="mx-0">
            <img :src="iconPath + 'ortho_k_icon.svg'" width="22" class="mr-2" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>CRT / Ortho-K</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/hybrids">
          <v-list-item-icon class="mx-0">
            <img
              src="https://www.eyedock.com/images/menu_icons/hybrid2_icon.svg"
              width="22"
              class="mr-2"
            />
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Hybrid Lenses</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2"></v-divider>
        <!-- <div class="overline">Indications</div> -->
        <v-subheader>Indications</v-subheader>

        <v-list-item to="/rgps/tag/presbyopia">
          <v-list-item-icon class="mx-0">
            <img
              :src="iconPath + 'rgp_bifocal_icon.svg'"
              width="22"
              class="mr-2"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Presbyopia</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/rgps/tag/irregular-cornea">
          <v-list-item-icon class="mx-0">
            <img
              :src="iconPath + 'topography_icon.svg'"
              width="22"
              class="mr-2"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Irregular Cornea</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item to="/rgps/list">
          <v-list-item-icon class="mx-0">
            <img
              :src="iconPath + 'all_rgps_icon.svg'"
              width="22"
              class="mr-2"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>All Lenses</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-divider class="my-2"></v-divider>
        <v-subheader>More</v-subheader>

        <!-- <div class="overline">More</div> -->
        <!-- <v-divider class="my-3"></v-divider> -->

        <v-list-item to="/rgps/companies">
          <v-list-item-icon class="mx-0">
            <!-- <v-icon small color="primary" class="ml-1 mr-2">mdi-factory</v-icon> -->
            <img :src="iconPath + 'factory.svg'" width="22" class="mr-2" />
          </v-list-item-icon>

          <v-list-item-content
            ><v-list-item-title> Companies</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/rgps/materials">
          <v-list-item-icon class="mx-0">
            <img
              :src="iconPath + 'rgp_button_icon.svg'"
              width="22"
              class="mr-2"
            />
          </v-list-item-icon>

          <v-list-item-content
            ><v-list-item-title> Materials</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "RgpMenuBtns",
  props: {},
  data: function () {
    return {
      iconPath: "https://eyedock.com/images/menu_icons/",
    };
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
